import { z } from 'zod'
export const POST_PURCHASE_RULE_JUNCTION_OPERATORS = ['AND', 'OR'] as const;
export const POST_PURCHASE_RULE_LINE_TYPES = [
    'order_contains_product',
    'not_order_contains_product',
    'customer_did_not_subscribe_to_club',
] as const;
const postPurchaseRuleLineSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('customer_did_not_subscribe_to_club'),
    }),
    z.object({
        type: z.enum(['order_contains_product', 'not_order_contains_product']),
        productId: z.string().min(1, 'Product is required'),
        minimumQuantity: z.number().int().positive().max(1000),
    }),
])

export const postPurchaseRuleFormSchema = z
    .object({
        ruleOperator: z.enum(POST_PURCHASE_RULE_JUNCTION_OPERATORS),
        priority: z.number().int().positive().nullable().optional(),
        offers: z.array(z.string()).default([]),
        lines: z.array(postPurchaseRuleLineSchema).default([]),
    })
    .refine(
        (value) => {
            const hasNonClubLine = value.lines.some((l) => l.type !== 'customer_did_not_subscribe_to_club')
            if (hasNonClubLine && !value.offers.length) {
                return false
            }
            return true
        },
        {
            message: 'At least one offer is required when conditions include product-based rules',
            path: ['offers'],
        }
    )
    .transform((value) => {
        const clubLine = value.lines.find((l) => l.type === 'customer_did_not_subscribe_to_club')
        if (clubLine) {
            return {
                ...value,
                lines: [clubLine],
                offers: [],
                ruleOperator: 'OR' as const,
            }
        }
        return value
    })

export type PostPurchaseRuleFormData = z.infer<typeof postPurchaseRuleFormSchema>
export type PostPurchaseRuleLine = z.infer<typeof postPurchaseRuleLineSchema>

